import React from 'react';
import {
  Button,
  getRehydratableName,
  Typography,
  Sizes,
  Heading,
  VerticalSpacing,
  VerticalSpacingSizes,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import {
  ButtonKind,
  ButtonColor,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ICommunityBannerProps } from './types';
import './index.css';
import ExportIcon from './ExportIcon';

export const CommunityBanner: React.FC<ICommunityBannerProps> = (props) => {
  const {
    title,
    description,
    link,
    buttonText,
    bannerImageUrl,
    bannerImageAltText,
  } = props;
  const getClassName = getClassNameFactory(CommunityBanner.displayName);

  return (
    <div
      data-rehydratable={getRehydratableName(CommunityBanner.displayName)}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <div
        className={getClassName({ descendantName: 'imageBlock' })}
        data-testid="CommunityBanner-image"
      >
        <img
          src={bannerImageUrl}
          alt={bannerImageAltText}
          height={120}
          width={185}
        />
      </div>
      <div className={getClassName({ descendantName: 'textBlock' })}>
        <Heading
          type={types.Large}
          boldType={boldTypes.black}
          className={getClassName({ descendantName: 'heading' })}
          data-testid="CommunityBanner-heading"
        >
          {title}
        </Heading>
        <VerticalSpacing size={VerticalSpacingSizes.XS}> </VerticalSpacing>
        <Typography
          type={Sizes.XTRASMALL}
          tag={TypographyTags.P}
          className={getClassName({ descendantName: 'description' })}
          data-testid="CommunityBanner-description"
        >
          {description}
        </Typography>
        <VerticalSpacing size={VerticalSpacingSizes.M}> </VerticalSpacing>

        <div className={getClassName({ descendantName: 'buttonWithLink' })}>
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.SECONDARY}
            shape="circular"
            href={link}
            newWindow={true}
            data-testid="shtBtnTitle"
            icon={ExportIcon}
            iconPosition={IconPosition.LEFT}
            block={true}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

CommunityBanner.displayName = 'CommunityBanner';
